import { FC, useMemo } from 'react';
import Select, { SelectProps } from '@components/DesignLibrary/Atoms/Select/Select';
import { useQuestionnaireContext, useQuestionnaireFormContext } from '@components/Questionnaire/QuestionnaireProvider';

const STATE_FIELD_KEY = 'districtOfState';
const STATE_OR_FEDERAL_FIELD_KEY = 'abpropertyfield1208';

const BankruptcyStatuteSelect: FC<SelectProps> = (props) => {
  const { federalExemptionsDataset, stateExemptionsDataset } = useQuestionnaireContext();
  const { formMethods } = useQuestionnaireFormContext();
  const { fieldsByKey } = useQuestionnaireContext();

  const selectedState = formMethods.watch(STATE_FIELD_KEY);
  const stateOrFederal = formMethods.watch(STATE_OR_FEDERAL_FIELD_KEY);

  const options = useMemo(() => {
    if (stateOrFederal === 'cpropertyclaimedasexemptfield35Federal' && federalExemptionsDataset?.data) {
      if (typeof federalExemptionsDataset?.data !== 'string') return [];
      return (JSON.parse(federalExemptionsDataset.data) as { table: Array<{ statute: string; name: string; }> })?.table
        ?.map(exemption => ({
          key: exemption.statute,
          label: `${exemption.statute} (${exemption.name})`,
        })) || [];
    }
    if (stateExemptionsDataset?.data && selectedState) {
      if (typeof stateExemptionsDataset?.data !== 'string') return [];
      const fullState = fieldsByKey[STATE_FIELD_KEY].options?.find(o => o.key === selectedState)?.label;
      if (fullState) {
        return (JSON.parse(stateExemptionsDataset.data) as { table: Array<{ statute: string; state: string; name: string; }> })?.table
          ?.filter((s) => s.state === fullState)
          ?.map(s => ({
            key: s.statute,
            label: `${s.statute} (${s.name})`,
          })) || [];
      }
    }
    return [];
  }, [federalExemptionsDataset, stateExemptionsDataset, selectedState, stateOrFederal, fieldsByKey]);

  return (
    <Select
      {...props}
      options={options}
    />
  );
};

export default BankruptcyStatuteSelect;
